'use client';

if (typeof window !== 'undefined') {
  import('brotli-wasm');
}

export async function compressData(data: unknown): Promise<string> {
  try {
    const brotliImport = (await import('brotli-wasm')).default;
    const json = JSON.stringify(data);
    const brotli = await brotliImport;
    const compressedJson = brotli.compress(new TextEncoder().encode(json));
    const base64Encoded = btoa(String.fromCharCode(...compressedJson));
    return base64Encoded;
  } catch (error) {
    throw new Error('Compression failed', { cause: error });
  }
}
